import DrawerModal from "./DrawerModal";
import Modal from "./Modal";

/**
 * Shorthand component to display a drawer type in mobile, and
 * a classic modal in desktop.
 * @param open
 * @param children
 * @param onClose
 * @param extraClasses
 * @return {JSX.Element}
 * @constructor
 */
const DynamicModal = ({
    open = false,
    children,
    onClose,
    extraClasses = {},
}) => {
    return (
        <>
            <DrawerModal
                open={open}
                onClose={onClose}
                extraClasses={{
                    ...extraClasses,
                    modal: (extraClasses?.modal ?? "") + " visible-mobile",
                }}
            >
                {children}
            </DrawerModal>
            <Modal
                open={open}
                onClose={onClose}
                extraClasses={{
                    ...extraClasses,
                    modal:
                        (extraClasses?.modal ?? "") +
                        " visible-desktop modal--full",
                }}
            >
                {children}
            </Modal>
        </>
    );
};

export default DynamicModal;
